import React from "react";
import MKButton from "components/MKButton";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";

// Imagini pentru galerie
import mocheta1 from "assets/images/poze-site/10-1-mocheta.webp";
import mocheta2 from "assets/images/poze-site/10-2-mocheta.webp";
import mocheta3 from "assets/images/poze-site/10-3-mocheta.webp";
import mocheta4 from "assets/images/poze-site/10-4-mocheta.webp";
import mocheta5 from "assets/images/poze-site/10-5-mocheta.webp";
import mocheta7 from "assets/images/poze-site/10-7-mocheta.webp";
import mocheta8 from "assets/images/poze-site/10-8-mocheta.webp";

const images = [
    mocheta1,
    mocheta2,
    mocheta3,
    mocheta4,
    mocheta5,
    mocheta7,
    mocheta8,
];

function ServicesSection() {
    return (
        <MKBox py={6}>
            <Container>
                <MKTypography variant="h2" textAlign="center" mb={4}>
                    Galerie foto – Curățenie pentru mochete și covoare
                </MKTypography>

                <Grid container spacing={3} justifyContent="center">
                    {images.map((img, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <MKBox
                                component="div"
                                sx={{
                                    position: "relative",
                                    width: "100%",
                                    paddingTop: "70%", // raport fix pt. încadrări egale
                                    overflow: "hidden",
                                    borderRadius: "lg",
                                    boxShadow: 3,
                                }}
                            >
                                <MKBox
                                    component="img"
                                    src={img}
                                    alt={`Galerie mochete ${index + 1}`}
                                    sx={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        objectPosition: "center",
                                    }}
                                />
                            </MKBox>
                        </Grid>
                    ))}
                </Grid>

                <MKButton
                    variant="gradient"
                    color="info"
                    size="large"
                    component="a"
                    href="/contact-curatenie"
                    sx={{ mt: 6, mx: "auto", display: "block" }}
                >
                    Solicită o vizită GRATUITĂ pentru ofertă!
                </MKButton>
            </Container>
        </MKBox>
    );
}

export default ServicesSection;
